import { CloudConnectionSettings } from "@/pages/DeploymentsPage/components/organisms/CloudConnectionSettings"

import type { TFunction } from "@/hooks/useTranslation"
import type { CloudConnectionSettingsCellRecord } from "@/pages/DeploymentsPage/components/organisms/CloudConnectionSettings"

// Only a cloud connection's row has settings
export const CloudConnectionSettingsCell = (t: TFunction) =>
  function CloudConnectionSettingsCellComponent(
    _: unknown,
    record: CloudConnectionSettingsCellRecord
  ) {
    return record.platform && record.connectionId ? (
      <CloudConnectionSettings
        platform={record.platform}
        connectionId={record.connectionId}
        t={t}
      />
    ) : null
  }
